<template>
  <div class="product-list" v-if="productList.length > 0">
    <div class="pro-item" v-for="(item, index) in productList" :key="index">
      <!-- <div class="ck-box">
        <el-checkbox v-model="item.isCheck" @change="selected(item)"></el-checkbox>
      </div>-->
      <div class="pro-img">
        <img :src="item.imgUrl" @click="$router.push({ path: '/proDetail', query: { coNu: item.co_Nu } })" />
      </div>
      <div class="pro-info">
        <p class="pr-no">{{ item.co_Nu }}</p>
        <p class="pr-na">{{ language === 'en' ? item.pr_En_Na : language === 'ru' ? item.basicThreeLanguage : item.pr_Na }}</p>
      </div>
      <div class="price-box">
        <p class="price">
          <span>{{ userInfo.symbol }}</span>
          {{ userInfo.status === 1 ? Number(item.price) : $t('viewPrice')}}
        </p>
        <!-- <p class="cart" :class="markCart(item.co_Nu) ? 'active' : ''" @click="handleToCart(item)"></p> -->
        <img
          src="../../assets/tianshi/xuanzhong.jpg"
          alt
          style="margin-right: 10px;"
          v-if="markCart(item.co_Nu)"
          @click="handleToCart(item)"
        />
        <img src="../../assets/tianshi/weixuanzhong.jpg" alt style="margin-right: 10px;" v-else @click="handleToCart(item)" />
      </div>
      <div class="price-caiji" v-if="userInfo.id">
        <p class="price">{{ item.ou_Lo || 0 }}PCS</p>
        <p class="price">{{ item.bulk_Stere || 0 }}CBM</p>
      </div>
    </div>
  </div>
</template>
<script>
import { addCartsApi, deletCartsApi } from '@/api/cart'
import { mapGetters, mapActions, mapState } from 'vuex'
export default {
  name: 'proList',
  props: {
    productList: {
      type: Array,
      default: () => []
    },
    cartList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      noImg: require('@/assets/noImg.jpg'),
      datas: []
    }
  },
  computed: {
    ...mapGetters('user', {
      userInfo: 'get_userInfo'
    }),
    ...mapGetters('operate', {
      gettingCart: 'getting_cart'
    }),
    // 语言
    ...mapState('operate', ['language']),

    // 标记购物车图标
    markCart() {
      return coNu => {
        // 购物车列表为空，直接返回标记
        return this.gettingCart.findIndex(item => item.co_Nu === coNu) > -1
      }
    }
  },
  methods: {
    ...mapActions('operate', {
      addCart: 'add_cart',
      deleteCart: 'delete_cart'
    }),
    // 添加到购物车
    handleToCart(item) {
      // 必须登陆后才能添加购物车
      if (Object.keys(this.userInfo).length === 0) {
        this.$message({
          message: this.$t('noLogin'),
          type: 'warning'
        })
        return
      }
      if (this.markCart(item.co_Nu)) {
        deletCartsApi({
          userId: this.userInfo.id,
          coNus: [item.co_Nu]
        }).then(res => {
          if (res.success) {
            this.deleteCart(item.co_Nu)
          }
        })
      } else {
        addCartsApi({
          client_Nu: this.userInfo.client_Nu,
          userId: this.userInfo.id,
          co_Nu: item.co_Nu,
          number: 1
        }).then(res => {
          if (res.success) {
            this.addCart({
              client_Nu: this.userInfo.client_Nu,
              userId: this.userInfo.id,
              co_Nu: item.co_Nu,
              fa_No: item.fa_No,
              imgUrl: item.imgUrl,
              in_En: item.in_En,
              number: 1,
              ou_Lo: item.ou_Lo,
              pr_En_Na: item.pr_En_Na,
              pr_Na: item.pr_Na,
              price: item.price
            })
          }
        })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.product-list {
  display: flex;
  flex-wrap: wrap;

  & .pro-item {
    position: relative;
    width: 348px;
    height: 389px;
    background-color: #fff;
    border-radius: 12px;
    margin-right: 16px;
    margin-bottom: 20px;
    overflow: hidden;
    &:nth-child(4n) {
      margin-right: 0;
    }

    & .ck-box {
      position: absolute;
      right: 5%;
      top: 1%;
    }

    & .pro-img {
      width: 348px;
      height: 261px;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      overflow: hidden;

      & img {
        width: auto;
        height: auto;
        max-width: 100%;
        max-height: 261px;
        transition-duration: 0.5s;

        &:hover {
          // transition-duration: 0.5s;
          // transform: scale(1.1);
        }
      }
    }

    & .pro-info {
      font-size: 14px;
      margin: 0 10px;
      & p {
        line-height: 30px;
        overflow: hidden;
        overflow: hidden;
        text-overflow: ellipsis;

        &.pr-no,
        &.pr-na {
          height: 30px;
        }
      }
    }
    & .price-caiji {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 0 10px;
      margin-top: 5px;
      & .price {
        font-size: 14px;
        font-weight: bold;
        color: #ff0000;

        & span {
          font-size: 14px;
        }
      }
    }
    & .price-box {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 0 10px;

      & .price {
        font-size: 14px;
        font-weight: bold;
        color: #ff0000;

        & span {
          font-size: 14px;
        }
      }

      img {
        cursor: pointer;
      }
    }
  }
}
</style>